<template>
  <div>
    {{a()}}
    <div>
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="change(item, index)"
          :class="['li', {'selected': item.selected}]"> {{item}} </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [1,2,3,4,5,6,7,8]
    }
  },
  methods: {
    change (item, index) {
      this.list[index] = 100
      this.list = JSON.parse(JSON.stringify(this.list))
    },
    a () {
      console.log(123)
    }
  }
}
</script>

<style>
ul {
  padding: 20px;
}
.li {
  color: #000;
}
.li.selected {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/edit-plan/test.vue